import { createFileRoute } from '@tanstack/react-router'
import { SettingsMcpAccess } from '@/features/settings/mcp-access'

export const Route = createFileRoute('/_authenticated/settings/mcp-access')({
  component: SettingsMcpAccess,
})
